const gobjUISettings =
{
    "en_US":
    {
        // #region Label

        "LBL_Login": "Log in",
        "LBL_Logout": "Logout",
        "LBL_CreateAccount": "Create",
        "LBL_BackToLogin": "Back to Login",
        "LBL_GoogleSignIn": "Continue with Google",
        "LBL_AppleSignIn": "Continue with Apple",
        "LBL_FacebookLogin": "Continue with Facebook",
        "LBL_SignUpMsg": "Don't have an account?",
        "LBL_SignUp": "Sign Up for free",
        "LBL_ForgotPassword": "Forgot Password?",
        "LBL_ForgotPasswordSub": "only for users with email as username",
        "LBL_ForgotPasswordSubmit": "Submit",
        "LBL_Forgot": "Forgot?",
        "LBL_Password": "Password",
        "LBL_Home": "Home",
        "LBL_Lessons": "Lessons",
        "LBL_Lesson": "Lesson",
        "LBL_Volume": "Volume",
        "LBL_NoteList": "NoteList",
        "LBL_Settings": "Settings",
        "LBL_Help": "Help",
        "LBL_Resources": "Resources",
        "LBL_LastAccess": "Last Access",
        "LBL_Account": "Account",
        "LBL_Subscription": "Subscription",
        "LBL_Content": "Content",
        "LBL_Time": "Time",
        "LBL_About": "About",
        "LBL_UserProfile": "User Profile",
        "LBL_FirstName": "First Name",
        "LBL_LastName": "Last Name",
        "LBL_Email": "Email",
        "LBL_Gender": "Gender",
        "LBL_Country": "Country",
        "LBL_BookList": "Book List",
        "LBL_ExpireBy": "Expire By",
        "LBL_AuthorizationCode": "Authorization Code (16 characters)",
        "LBL_AuthorizationMemo": "For questions regarding subscription, please contact usa@betterchinese.com.",
        "LBL_WebSubscriptionDesc": "The subscriptions below include all four volumes of Discovering Chinese Pro.",
        "LBL_ContentSettingsTitle": "Content Settings",
        "LBL_SystemLanguage": "System Language",
        "LBL_English": "English",
        "LBL_ChineseCharacters": "Chinese Characters",
        "LBL_TimeZone": "Time Zone",
        "LBL_DST": "DST",
        "LBL_NA": "N/A",
        "LBL_AboutUs": "About Us:",
        "LBL_AboutUsMsg": "Founded by educators from Columbia University and the UN, Better Chinese is a leading publisher of Mandarin curricula for students of all levels, from pre-k to college. Better Chinese is incredibly honored to be the Curriculum Partner, along with ACTFL/NCSSFL, of the US-China Strong initiative (uschinastrong.org), which is tasked to foster 1 million US K-12 students learning Chinese by 2020.",
        "LBL_AboutDCP": "About DCP:",
        "LBL_AboutDCPMsg": "Discovering Chinese Pro - a groundbreaking 21st century Chinese learning program based on our State-Adopted Discovering Chinese series - is designed for middle/high school students. We completely restructured this resource by combining technology and hard copy books, to ensure that teachers can deliver lessons with ease, with best practices built into not just the articulated sequence but also the methods of delivery.",
        "LBL_Male": "Male",
        "LBL_Female": "Female",
        "LBL_Chapter": "Chapter",
        "LBL_Page": "out of",
        "LBL_Glossary": "Glossary",
        "LBL_SearchLabel": "Search Vocabulary",
        "LBL_Assign": "Assign",
        "LBL_Name": "Name",
        "LBL_StartDate": "Start Date",
        "LBL_DueDate": "Due Date",
        "LBL_Assignment": "Assignment",
        "LBL_Assessment": "Assessment",
        "LBL_Assessments": "Assessments",
        "LBL_BCApps": "Other Subscriptions",
        "LBL_ContentsAccess": "Contents Access",
        "LBL_AssignmentSetting": "Assignment Settings",
        "LBL_ClassManagement": "Class Management",
        "LBL_Due": "Due",
        "LBL_AssignReport": "Assignment Report",
        "LBL_Completed": "Completed",
        "LBL_AverageScore": "Average Score",
        "LBL_TBD": "TBD",
        "LBL_SuggestedAnswer": "Suggested Answer(s):",
        "LBL_Practice": "Practice",
        "LBL_PracticeMsg": "Show Practice To Student",
        "LBL_Review": "Review",
        "LBL_ReviewMsg": "Show Review To Student",
        "LBL_AnswerMsg": "Show correct answer after submission",
        "LBL_SubmissionMsg": "Allow Submission",
        "LBL_Score": "Score",
        "LBL_AddComments": "Add Comments:",
        "LBL_TeachersComments": "Teacher's Comments",
        "LBL_StudentsAnswer": "Student's Answer",
        "LBL_CompositionAddComments": "Add Comments",
        "LBL_No": "No.",
        "LBL_Chinese": "Chinese",
        "LBL_Pinyin": "Pinyin",
        "LBL_PartsOfSpeech": "Parts of speech",
        "LBL_Definition": "Definition",
        "LBL_Note": "Note",
        "LBL_ShowPinyin": "Pinyin",
        "LBL_ShowCharacters": "Characters",
        "LBL_ShowEnglish": "English",
        "LBL_PlayAll": "Play All",
        "LBL_UsageExample": "Usage example",
        "LBL_Radical": "Radical",
        "LBL_Progress": "Progress",
        "LBL_DownloadImagePageMsg": "Right Click and Save!",
        "LBL_DownloadImage": "Download Image",
        "LBL_EmailVerifiedTitle": "Verify your Email",
        "LBL_EmailVerifiedMsg": "After verifying your email, you will be able to use your email address to log in to all products. We can also keep you updated on new product changes. You may verify your email in the Settings later.",
        "LBL_TermsOfUseTitle": "End User Licensing Agreement",
        "LBL_TermsOfUseCheck": "I accept the new Agreement.",
        "LBL_Label": "Label",
        "LBL_Version": "Version",
        "LBL_BCCorporation": "Copyright © 2017 Better Chinese Corporation. All rights reserved.",
        "LBL_Edit": "Edit",
        "LBL_ChangePassword": "Change Password",
        "LBL_DeleteMyAccount": "Delete My Account",
        "LBL_Message": "Message",
        "LBL_ChooseAssignment": "Choose an Assignment",
        "LBL_SelectAll": "Select All",
        "LBL_Redeemed": "Redeemed",
        "LBL_FreeResource": "Free Resource",
        "LBL_TextBookAudio": "Textbook Audio",
        "LBL_WorkBookAudio": "Workbook Audio",
        "LBL_WorkBookAnswerKey": "Workbook Answer Key",
        "LBL_AssessmentVideoMsg": "Only available on iPad.",
        "LBL_ToolTipTeacher": "Tap here to assign homework, add notes, and navigate back to the main page.",
        "LBL_ToolTipStudent": "Tap here to add notes, and navigate back to main page.",
        "LBL_NoteTip": "Tap here to take notes.",
        "LBL_AssignTip": "Tap here to assign Practice / Review.",
        "LBL_ResourcesTip": "Tap here to download pacing guide, writing template and other free resources.",
        "LBL_GCTip": "assign this exercise in Google Classroom",
        "LBL_SettingsAccountMemo": "*Changes will be updated after re-login.",
        "LBL_NotSubmitted_EN": "Not submitted",
        "LBL_GradePending_EN": "Grade pending",
        "LBL_NeedHelp_EN": "Need help",
        "LBL_Completed_EN": "Completed",
        "LBL_LastSaved": "Last saved",
        "LBL_PracticeSheet": "Practice Sheet",
        "LBL_Date": "Date",
        "LBL_Bulletin": "Bulletin",
        "LBL_EditBulletin": "Edit Bulletin",
        "LBL_NotScore": "--",
        "LBL_LastAssignmentCompletion": "Last Assignment Completion",
        "LBL_LastAssignmentScore": "Last Assignment Score",
        "LBL_ViewMoreDetails": "View more details >>",
        "LBL_OverView": "Overview",
        "LBL_NotSelect": "Not Select",
        "LBL_TapToStartRecording": "Tap to Start Recording",
        "LBL_MicTipAgain": "Please tap mic again",
        "LBL_NextTip": "Please tap button to next sentence",
        "LBL_AudioTip": "Tap here to listen your voice.",
        "LBL_History": "History",
        "LBL_Status": "Status",
        "LBL_Once": "Once",
        "LBL_Twice": "Twice",
        "LBL_Unlimited": "Unlimited",
        "LBL_YourScore": "Your Score",
        "LBL_AddImage": "Add Image",
        "LBL_WritingTemplate": "Writing Template",
        "LBL_Others": "Others",
        "LBL_TitleCreateAccount": "Create an Account",
        "LBL_EmailSent": "Email sent!",
        "LBL_SRTitle4Expired": "Your subscription has expired.",
        "LBL_SRTitle4WillExpire": "Your subscription will expire soon.",
        "LBL_SRTitle4Expired4Trial": "Your trial has expired.",
        "LBL_SRTitle4WillExpire4Trial": "Your trial will expire.",
        "LBL_ProductDesc": "The subscriptions below include all four volumes of Discovering Chinese Pro.",
        "LBL_ExpirationDate": "Expiration Date:",
        "LBL_ExpirationMemo": "For school and group purchases, please contact us for details.",
        "LBL_SRDoNotShow": "Do not show this message again.",
        "LBL_SRDoNotShowMemo": "You can always check these subscriptions in the settings.",
        "LBL_PerMonth": "per month",
        "LBL_MonthFree": "1st Month Free*",
        "LBL_OrderNow": "Order now",
        "LBL_DueToday": "due today",
        "LBL_AI": "AI Story Time",
        "LBL_Library": "Ebook Library",
        "LBL_BI": "Better Immersion",
        "LBL_MC": "Modern Chinese Companion Platform",
        "LBL_ImportantInformationForParents": "Important Information for Parents",
        "LBL_EssentialQuestions": "Essential Questions",
        "LBL_PacingGuideOnline": "Pacing Guide (online user)",
        "LBL_PacingGuideBook": "Pacing Guide (book user)",
        "LBL_SentVerifySuccessed": "Sent successfully. Now you can go to your email to finish the verification. Don't forget to check your spam as well.",
        "LBL_ClassIDPlaceHolder": "Class ID (skip if you don't have one)",
        "LBL_UsernameEmailPlaceHolder": "Username (Email)",
        "LBL_UserNamePlaceHolder": "Username",
        "LBL_PasswordPlaceHolder": "Password",
        "LBL_ConfirmPasswordPlaceHolder": "Confirm password",
        "LBL_FirstNamePlaceHolder": "First Name",
        "LBL_LastNamePlaceHolder": "Last Name",
        "LBL_SearchPlaceHolder": "Search",
        "LBL_AnswerScorePlaceHolder": "Please provide a score between 0-100",
        "LBL_InputAnswerPlaceHolder": "Type your composition here.",
        "LBL_AssignMessagePlaceHolder": "Type your message here.",
        "LBL_WritingCommentsPlaceHolder": "Type your comments here.",
        "LBL_EmailPlaceHolder": "Email",
        "LBL_AnswerPlaceHolder": "Type your answer here.",
        "LBL_PageOf": "of",
        "LBL_Sentences": "Sentences",
        "LBL_DownloadAssignmentContentTitle": "Learn Chinese more effectively with Discovering Chinese Pro Assessment!",
        "LBL_DownloadAssignmentDescription": "DCP Asseessment provides you with new tools to track your learning progress and review your skills.",

        // #endregion Label

        // #region Button

        "BTN_Submit": "Submit",
        "BTN_GoToLesson": "Go To Lesson",
        "BTN_Volume": "Volume",
        "BTN_Buy": "Buy",
        "BTN_View": "View",
        "BTN_Simplified": "Simplified",
        "BTN_Traditional": "Traditional",
        "BTN_Cancel": "Cancel",
        "BTN_Yes": "Yes",
        "BTN_No": "No",
        "BTN_Back": "Back",
        "BTN_StillContinue": "Still continue",
        "BTN_FinishMyExercise": "Finish my exercise",
        "BTN_Download": "Download",
        "BTN_DownloadDCPAssessment": "Download DCP Assessment",
        "BTN_ON": "ON",
        "BTN_OFF": "OFF",
        "BTN_Update": "Update",
        "BTN_Save": "Save",
        "BTN_History": "History",
        "BTN_Result": "Result",
        "BTN_Score": "Score it",
        "BTN_Later": "Later",
        "BTN_Previous": "Previous",
        "BTN_Next": "Next",
        "BTN_PreviousChapter": "Previous Chapter",
        "BTN_NextChapter": "Next Chapter",
        "BTN_ClearAnswer": "Clear Answer",
        "BTN_Show": "Show",
        "BTN_Hide": "Hide",
        "BTN_VerifyNow": "Verify Now",
        "BTN_Agree": "Agree",
        "BTN_Detail": "Detail",
        "BTN_Delete": "Delete",
        "BTN_Confirm": "Confirm",
        "BTN_More": "More",
        "BTN_PasteStudentAnswer": "Paste Student Answer",
        "BTN_Consent": "I Consent",
        "BTN_Verify": "Verify",
        "BTN_Glossary": "Glossary",
        "BTN_ICPVersion": "京ICP备2021037755号-1",

        // #endregion Button

        // #region Message

        "PROMPT_DeleteAssignment_Title": "Delete Assignment",
        "PROMPT_DeleteAssignment_Msg": "Permanently delete this assignment? All student records ralating to this assignment will be lost",
        // 聽寫拼音資訊     Tim16.08.28
        "MSG_PinyinDictationInfo_Title": "To add the Chinese keyboard please go to",
        "MSG_PinyinDictationInfo_Msg": "Settings > General > Keyboard > International Keyboards > Add New Keyboard > Chinese-Simplified / Traditional",
        "MSG_Resource_NoAuthorized": "We are sorry, you do not have access to this page.",
        "MSG_SubmitSuccess": "Submitted successfully!",
        "MSG_SubmitSuccess4Assign": "Submitted Successfully!\n\nDo you want to assign the same content to another class?",
        "MSG_AssignmentSubmitConfirm": "You are about to submit the assignment. Click OK to continue.",
        "MSG_AssignmentSubmitCheckNotAllQuestionsHaveAnswer": "You have not answered all the questions. Do you want to submit anyway?",
        "MSG_AssignmentSubmitCheck4One": "You are about to submit the assignment. Click OK to continue.",
        "MSG_AnswerSaveCheck": "Please finish and submit your answer before moving to the next section.",
        "MSG_AudioRecordMemo": "Bluetooth headsets are not compatible with Safari, please change your browser to Chrome or use other headsets.",
        "MSG_EmptyList_NoNotes": "No notes in this volume",

        // #endregion Message

        // #region Error Message

        "ERR_InputUsernameAndPassword": "Please confirm your user name and password!",
        "ERR_AuthorizationCode": "Please enter 16 characters",
        "ERR_NpLoginSubscription": "Please log in or register an account so that you can access the content from other devices.\n\nIf you don't want to do it now, please click \"Cancel\", you can always come back and register.",
        "ERR_InputAssignMessage": "Please insert Assignment Message.",
        "ERR_DueDateEarlyToday": "Due Date cannot be erlier than Today.",
        "ERR_StartDateEarlyToday": "Start Date cannot be erlier than Today.",
        "ERR_DueDateEarlyStartDate": "Due Date cannot be earlier than Start Date.",
        "ERR_ChangeNewStudentDueDateEarlyToday": "Please change the due date before assigning it to a new student.",
        "ERR_AssignValidationStudentList": "Please select at least one student.",
        "ERR_AnswerScoreNotEntered": "Please grade before submitting.",
        "ERR_AnswerScoreExceed": "Please provide a score between 0-100.",
        "ERR_GoToLUNoAuthorizedGoToIAP": "We are sorry, you do not have access to this volume. Please subscribe now or contact your school account manager directly to subscribe.",
        "ERR_NoInternetService4DownloadLessonData": "New lessons can not be downloaded. Please check your network connection.",
        "ERR_IAPProcedureHavenotCompleted": "In App Purchase procedure haven't completed.",
        "ERR_ReceiptNotValidMsg": "Purchase error: the receipt is invalid. Please email us at \"usa@betterchinese.com\".",                  // -120063 Receipt not valid
        "ERR_SomebodyIsReusingAReceiptMsg": "Purchase error: the receipt already used. Please email us at \"usa@betterchinese.com\".",      // -120064 Somebody is reusing a receipt
        "ERR_ReceiptProductIDErrorMsg": "Purchase error: the Receipt ID error. Please email us at \"usa@betterchinese.com\".",              // -120065 Receipt Product ID Error
        "ERR_AuthorizationDefaultErrorMsg": "Authorization has failed, Please email us at \"usa@betterchinese.com\".",                      // -120057 購買 預設未定義錯誤
        "ERR_AuthorizationNotResponseMsg": "Authorization has failed, Please email us at \"usa@betterchinese.com\".",                       // -120058 Soap Error Processing Request
        "ERR_ResetForgotPassword_NotAllowedChangePassword_Msg": "Your account is not allowed to change password. Please contact your instructor or us at usa@betterchinese.com to change it for you.",
        "ERR_ResetForgotPassword_NotVerified_Msg": "Your email has not been verified yet\nIf you're school user, please contact your school account manager, or email us at usa@betterchinese.com for further assistance.",
        "ERR_ResetForgotPassword_EmailNotExisted_Msg": "Please contact your instructor or us at usa@betterchinese.com to change your password.",
        "ERR_VEExistEmailWithOtherAccountID_Msg": "The email you entered has existed.",     // -140186,  // 你輸入的信箱已存在 158
        "ERR_VENotYetClickVerifyLink_Msg": "El enlace de verificación le fue enviado exitosamente. Si no puede encontrar el enlace, verifique su correo no deseado.", // -140171,  // 再次寄送認證信到你的信箱 153
        "ERR_VEAlreadyVerified_Msg": "The email already verified",                          // -140172,  // 此連結已驗證過 154
        "ERR_UnknownFunction_Msg": "Unknown Function",
        "ERR_DownloadFileFail": "Download File Fail.",
        
        // #endregion Error Message

        // #region Alert Message

        "MSG_Alert_Msg_BlockedInstructor": "This section has been blocked by your instructor.",
        "MSG_Alert_Msg_TestedCountExceededOnce": "You are only allowed to submit once by your instructor.",
        "MSG_Alert_Msg_TestedCountExceededTwice": "You are only allowed to submit twice by your instructor.",
        "MSG_Alert_Msg_BlockedInstructorPractice": "Please contact your instructor to unblock your Practice.",
        "MSG_Alert_Msg_BlockedInstructorReview": "Please contact your instructor to unblock your Review.",
        "MSG_Alert_Msg_NoLessonSection4Assign": "You haven't chosen the lesson and section yet. Do you just want to send out the message?",
        "MSG_Alert_Msg_NoLesson4Assign": "You haven't chosen the lesson yet. Please choose one unless you just want to send out the message.",
        "MSG_Alert_Msg_EmailIsFormatFail": "Please enter a valid email address.",   // reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;
        "MSG_Alert_Msg_PasswordLengthIsShort": "The lenght of password should be between 4 and 16.",
        "MSG_Alert_Msg_ConfirmYourPassword": "Confirm Your Password",
        "MSG_Alert_Msg_FirstNameNull": "Please fill in your first name.",
        "MSG_Alert_Msg_LastNameNull": "Please fill in your last name.",
        // APP SR
        "MSG_Alert_MicrophoneAccessDenied": "Please go to iOS Settings > Privacy > Microphone to allow 奇妙中文 to access the Microphone.",
        // Google SR Error
        // "MSG_Alert_Title_SR_Err": "Speech Recognition Error",
        "MSG_Alert_Google_SR_Err_NoSpeechAndNoResultMeetUpperBound": "Your voice cannot be detected or recognized. Please speak louder, or reduce background noise.",
        // Google SR Not Support
        "MSG_Alert_Title_Google_SR_NotSupport": "Browser Not Supported",
        "MSG_Alert_Msg_Google_SR_NotSupport": "Please use Google Chrome or iPad to play this game.",
        "MSG_Alert_Msg_Audio_Record_NotSupport": "Please use Google Chrome or iPad to use this function.",
        "MSG_Alert_Title_WebAudioRecorderInitErr": "Audio Recorder Error",
        "MSG_Alert_Title_AudioRecordingError": "Audio Recording Error",
        "MSG_Alert_Msg_WebAudioRecorderInitErr": "Please check your browser setting to allow microphone access.",
        "MSG_Alert_Msg_WebAudioRecorderDetectMicrophone": "Your device needs a working microphone to continue.",
        "MSG_Alert_Msg_AppAudioRecordingUnknownError": "Audio Recording Error",
        "MSG_Alert_EmailSent": "An email with instructions on how to reset your password has been sent to @UserName@.<br/><br/> Check your spam or junk folder if you don't see the email in your inbox.<br/><br/> If you still have problems, please contact us at 888-384-0902 or usa@betterchinese.com.",
        "MSG_VerifiedSuccessfully": "Verified successfully!",
        "MSG_ForgotPassword": "If your username is not an email, please contact your instructor or us at usa@betterchinese.com to reset your password.",
        "MSG_Alert_Web_Subscribe_Successfully": "If you subscribe successfully, please update your subscription.",
        "MSG_Alert_GoogleSignInFail": "Google Sign In fail, please try again ...",

        // #endregion Alert Message

        // #region Web Service Error Message and Error Code

        "ERR_WSTimeout_No": -21203,
        "ERR_WSTimeout_Title": "Network Error",
        "ERR_WSTimeout_Msg": "Network connection timed out, please check your network settings or try again later.",
        
        "ERR_WSNetworkGeneric_No": -21204,
        "ERR_WSNetworkGeneric_Title": "Network Error",
        "ERR_WSNetworkGeneric_Msg": "Network connection is unstable or Server is not reachable, please check your network settings or try again later.",
        
        "ERR_ResetForgotPassword_No": -31101,
        "ERR_ResetForgotPassword_Title": "Reset Password failed",
        "ERR_ResetForgotPassword_Msg": "Please try again later or email us at \"usa@betterchinese.com\" with the error code: ",
        "ERR_ResetForgotPassword_CouldNotFind_Msg": "Your username does not exist, please try again or contact us at usa@betterchinese.com to change your password.",
        
        "ERR_GetAccountAuthorized_No": -31103,
        "ERR_GetAccountAuthorized_Title": "Get Account Authorized failed",
        "ERR_GetAccountAuthorized_Msg": "Get Account Authorized failed",
        
        "ERR_ResetStudentPassword_No": -31105,
        "ERR_ResetStudentPassword_Title": "Reset Password failed",
        "ERR_ResetStudentPassword_Msg": "Reset Password failed",
        
        "ERR_AuthProvisioning_No": -31106,
        "ERR_AuthProvisioning_Title": "Auth Provisioning failed",
        "ERR_AuthProvisioning_Msg": "Auth Provisioning failed",
        
        "ERR_GetDCPContentJson_No": -31107,
        "ERR_GetDCPContentJson_Title": "Getting Content Files failed",
        "ERR_GetDCPContentJson_Msg": "Getting Content Files failed",
        
        "ERR_GetAccountStorageForSencha_No": -31108,
        "ERR_GetAccountStorageForSencha_Title": "Get Account Storage failed",
        "ERR_GetAccountStorageForSencha_Msg": "Get Account Storage failed",
        
        "ERR_SaveAccountStorageByBase64ForSencha_No": -31109,
        "ERR_SaveAccountStorageByBase64ForSencha_Title": "Save Account Storage failed",
        "ERR_SaveAccountStorageByBase64ForSencha_Msg": "Save Account Storage failed",
        
        "ERR_CheckGlossaryUpdateInfo_No": -31111,
        "ERR_CheckGlossaryUpdateInfo_Title": "System Error",
        "ERR_CheckGlossaryUpdateInfo_Msg": "Checking Glossary Update Info failed: ",
        
        "ERR_GetGlossaryData_No": -31112,
        "ERR_GetGlossaryData_Title": "System Error",
        "ERR_GetGlossaryData_Msg": "Get Glossary data failed: ",
        
        "ERR_GetNoteList_No": -31114,
        "ERR_GetNoteList_Title": "System Error",
        "ERR_GetNoteList_Msg": "Get Note List failed: ",
        
        "ERR_GetNoteInfo_No": -31115,
        "ERR_GetNoteInfo_Title": "System Error",
        "ERR_GetNoteInfo_Msg": "Get Note Info failed: ",
        
        "ERR_GetTeacherClassAssignment_No": -31117,
        "ERR_GetTeacherClassAssignment_Title": "Get backend data error",
        "ERR_GetTeacherClassAssignment_Msg": "Get teacher class assigment failed: ",
        
        "ERR_DeleteClassAssignment_No": -31118,
        "ERR_DeleteClassAssignment_Title": "Delete Assignment error",
        "ERR_DeleteClassAssignment_Msg": "Delete assignment failed: ",
        
        "ERR_EditAssignment_No": -31121,
        "ERR_EditAssignment_Title": "Save Edit data error",
        "ERR_EditAssignment_Msg": "Save Edit Data failed: ",
        
        "ERR_SwitchSectionShow_No": -31132,
        "ERR_SwitchSectionShow_Title": "Update Class Settings error",
        "ERR_SwitchSectionShow_Msg": "Update Contents Access failed: ",
        
        "ERR_GetClassMemberDataList_No": -31133,
        "ERR_GetClassMemberDataList_Title": "Get Class Member Data error",
        "ERR_GetClassMemberDataList_Msg": "Get Class Member Data failed: ",
        
        "ERR_TeacherScoreAssignment_No": -31137,
        "ERR_TeacherScoreAssignment_Title": "Teacher Score Assignment error",
        "ERR_TeacherScoreAssignment_Msg": "Teacher Score Assignment failed: ",
        
        "ERR_UploadAssignmentResult_No": -31138,
        "ERR_UploadAssignmentResult_Title": "Upload Assignment Result error",
        "ERR_UploadAssignmentResult_Msg": "Upload Assignment Result failed: ",
        
        "ERR_GetDCPResource_No": -31139,
        "ERR_GetDCPResource_Title": "Get Resource Data Error",
        "ERR_GetDCPResource_Msg": "Get Resource Data failed, please re-login again.",
        
        "ERR_AccountAcceptTerms_No": -31140,
        "ERR_AccountAcceptTerms_Title": "Send Accept Terms Error",
        "ERR_AccountAcceptTerms_Msg": "Send Accept Terms failed, please try again!",
        
        "ERR_GetAccountAuthorizedInfo_No": -31141,
        "ERR_GetAccountAuthorizedInfo_Title": "Get Authorized Info Error",
        "ERR_GetAccountAuthorizedInfo_Msg": "Get Authorized Info failed, please try again!",
        
        "ERR_SetAccountPreferences_No": -31142,
        "ERR_SetAccountPreferences_Title": "Set Account Preferences Error",
        "ERR_SetAccountPreferences_Msg": "Set Account Preferences failed, please try again!",
        
        "ERR_UpdateLastAccessedLU_No": -31143,
        "ERR_UpdateLastAccessedLU_Title": "Update Last Account Data Error",
        "ERR_UpdateLastAccessedLU_Msg": "Update Last Account Data failed, please try again!",
        
        "ERR_GetClassAccAssignmentStatus4Student_No": -31148,
        "ERR_GetClassAccAssignmentStatus4Student_Title": "Get Progress Data Error",
        "ERR_GetClassAccAssignmentStatus4Student_Msg": "Get Progress Data Failed: ",
        
        "ERR_AuthProvisioningExpire_No": -31150,
        "ERR_AuthProvisioningExpire_Title": "Auth Provisioning failed",
        "ERR_AuthProvisioningExpire_Msg": "This code has been redeemed. Please go to our website to purchase a new code!",
        
        "ERR_AuthProvisioningRedeemed_No": -31151,
        "ERR_AuthProvisioningRedeemed_Title": "Auth Provisioning failed",
        "ERR_AuthProvisioningRedeemed_Msg": "This code has been redeemed.",
        
        "ERR_GetAssignmentAssignAnswer_No": -31152,
        "ERR_GetAssignmentAssignAnswer_Title": "Get Assignment Answer Error",
        "ERR_GetAssignmentAssignAnswer_Msg": "Get Assignment Answer failed.",
        
        "ERR_CreateNewAssignmentByLU_No": -31153,
        "ERR_CreateNewAssignmentByLU_Title": "Create Assignment Data error",
        "ERR_CreateNewAssignmentByLU_Msg": "Create Assignment Data failed: ",
        
        "ERR_GetClassNewAssignmentDetail_No": -31153,
        "ERR_GetClassNewAssignmentDetail_Title": "Get Assignment Detail Error",
        "ERR_GetClassNewAssignmentDetail_Msg": "Get Assignment Detail failed.",
        
        "ERR_GetClassAccAssignmentStatus4Teacher_No": -31154,
        "ERR_GetClassAccAssignmentStatus4Teacher_Title": "Get Progress Data Error",
        "ERR_GetClassAccAssignmentStatus4Teacher_Msg": "Get Progress Data Failed: ",
        
        "ERR_GetAssigneeNewAssignList_No": -31155,
        "ERR_GetAssigneeNewAssignList_Title": "Get Assign List Score Error",
        "ERR_GetAssigneeNewAssignList_Msg": "Get Assign List Score failed.",
        
        "ERR_UpdateNote_No": -31157,
        "ERR_UpdateNote_Title": "UpdateNote Error",
        "ERR_UpdateNote_Msg": "UpdateNote failed.",
        
        "ERR_GetKeys4Systems_No": -31159,
        "ERR_GetKeys4Systems_Title": "Get Keys for Systems Error",
        "ERR_GetKeys4Systems_Msg": "Get Keys for Systems Failed: ",
        
        "ERR_CreateUser4App_No": -31160,
        "ERR_CreateUser4App_Title": "Create Account Error",
        "ERR_CreateUser4App_Msg": "Create Account failed, please try again!",
        "ERR_CreateUser4App_Repeat_Title": "Create Account Error",
        "ERR_CreateUser4App_Repeat_Msg": "This email already exists, please choose another.",
        
        "ERR_UploadAssignmentTmpResult_No": -31162,
        "ERR_UploadAssignmentTmpResult_Title": "Save Assignment Result error",
        "ERR_UploadAssignmentTmpResult_Msg": "Save Assignment Result failed: ",
        
        "ERR_UpdateProductCounter_No": -31163,
        "ERR_UpdateProductCounter_Title": "Update Product Counter error",
        "ERR_UpdateProductCounter_Msg": "Update Product Counter failed: ",
        
        "ERR_AccountAcceptPCL_No": -31164,
        "ERR_AccountAcceptPCL_Title": "Send Accept Parent Letter Error",
        "ERR_AccountAcceptPCL_Msg": "Send Accept Parent Letter failed, please try again!",
        
        "ERR_GetSubscriptionReminder_No": -31166,
        "ERR_GetSubscriptionReminder_Title": "Get Subscription Reminder Data Error",
        "ERR_GetSubscriptionReminder_Msg": "Get Subscription Reminder Data failed: ",
        
        "ERR_App_OpenIAP_No": -32006,
        "ERR_App_OpenIAP_Title": "In App Purchase Error",
        "ERR_App_OpenIAP_Msg": "In App Purchase Failed: ",
        
        "ERR_SendAccountVerifyEmail_No": -32008,
        "ERR_SendAccountVerifyEmail_Title": "Send Verify Email Error",
        "ERR_SendAccountVerifyEmail_Msg": "Send Verify Email Failed",
        
        "ERR_VerifyAccountEmail_No": -32009,
        "ERR_VerifyAccountEmail_Title": "Verify Email Error",
        "ERR_VerifyAccountEmail_Msg": "Verify Email Failed: ",
        
        "ERR_GetListeningPDFFileKeyFromFS_No": -32010,
        "ERR_GetListeningPDFFileKeyFromFS_Title": "Get PDF File Key Error",
        "ERR_GetListeningPDFFileKeyFromFS_Msg": "Get PDF File Key Failed",
        
        "ERR_iOSInAppPurchaseErrorDefault_No": -21130,
        "ERR_iOSInAppPurchaseErrorDefault_Title": "In App Purchase Error",
        "ERR_iOSInAppPurchaseErrorDefault_Msg": "In App Purchase Fail. ",
        
        "ERR_iOSInAppPurchaseProductIDFail_No": -21131,
        "ERR_iOSInAppPurchaseProductIDFail_Title": "In App Purchase Error",
        "ERR_iOSInAppPurchaseProductIDFail_Msg": "In App Purchase Product ID Fail. ",
        
        "ERR_iOSInAppPurchaseErrorWebServiceFailedd_No": -21132,
        "ERR_iOSInAppPurchaseErrorWebServiceFailed_Title": "In App Purchase Error",
        "ERR_iOSInAppPurchaseErrorWebServiceFail_Msg": "In App Purchase Web Service Fail. ",
        
        "ERR_iOSInAppPurchaseErrorNoReceiptFailed_No": -21133,
        "ERR_iOSInAppPurchaseErrorNoReceiptFailed_Title": "In App Purchase Error",
        "ERR_iOSInAppPurchaseErrorNoReceiptFailed_Msg": "In App Purchase Get Receipt Fail. ",
        
        "ERR_iOSInAppPurchaseErrorReceiptDataProcessedFailed_No": -21134,
        "ERR_iOSInAppPurchaseErrorReceiptDataProcessedFailed_Title": "In App Purchase Error",
        "ERR_iOSInAppPurchaseErrorReceiptDataProcessedFailed_Msg": "Process Receipt Data Fail. ",

        // #endregion Web Service Error Message and Error Code
        
        // #region Load Mask Message

        "MSG_LoadMask_ResetForgotPassword": "Reset Password, ...",
        "MSG_LoadMask_GetAccountAuthorized": "Get Account Authorized, ...",
        "MSG_LoadMask_GetAccountDashboard": "Get Account Dashboard, ...",
        "MSG_LoadMask_AuthProvisioning": "Auth Provisioning, ...",
        "MSG_LoadMask_GetDCPContentJson": "Getting Content Files, ...",
        "MSG_LoadMask_GetAccountStorageForSencha": "Get Account Storage, ...",
        "MSG_LoadMask_SaveAccountStorageByBase64ForSencha": "Save Account Storage, ...",
        "MSG_LoadMask_GetGlossaryUpdateInfo": "Loading Glossary Updates...",
        "MSG_LoadMask_GetGlossary": "Loading Glossary...",
        "MSG_LoadMask_GetNoteList": "Loading Notes...",
        "MSG_LoadMask_GetNote": "Opening Note Pad...",
        "MSG_LoadMask_UpdateNote": "Update Note Data...",
        "MSG_LoadMask_GetAssignmentData": "Loading assignment...",
        "MSG_LoadMask_DeleteAssignment": "Deleting Assignment.",
        "MSG_LoadMask_EditAssignment": "Saving Assignment.",
        "MSG_LoadMask_GetClassMemberDataList": "Loading student records...",
        "MSG_LoadMask_SwitchSectionShow": "Updating content Access.",
        "MSG_LoadMask_LoadIntroduction": "Loading Introduction...",
        "MSG_LoadMask_LoadImage": "Loading Image Data...",
        "MSG_LoadMask_GetDCPResource": "Get Resource Data...",
        "MSG_LoadMask_AccountAcceptTerms": "Send Accept Terms",
        "MSG_LoadMask_GetAccountAuthorizedInfo": "Get Authorized Info...",
        "MSG_LoadMask_SetAccountPreferences": "Set Account Preferences...",
        "MSG_LoadMask_GetClassAccAssignmentStatus4Student": "Get Progress Data, ...",
        "MSG_LoadMask_GetPinyinFileContent": "Getting Pinyin File Data, ...",
        "MSG_LoadMask_UploadNewAssignmentResult": "Upload Assignment Result",
        "MSG_LoadMask_GetAssignmentAssignAnswer": "Get Assignment Answer, ...",
        "MSG_LoadMask_CreateNewAssignmentByLU": "Create Assignment Data...",
        "MSG_LoadMask_GetClassNewAssignmentDetail": "Loading Assignment, ...",
        "MSG_LoadMask_GetClassAccAssignmentStatus4Teacher": "Get Progress Data, ...",
        "MSG_LoadMask_LoadOpenWeb": "Loading Web Data, ...",
        "MSG_LoadMask_GetAssigneeNewAssignList": "Get Score Data List, ...",
        "MSG_LoadMask_LoadAudioData": "Loading Audio Data, ...",
        "MSG_LoadMask_InitSR": "Initing Speech Recognition, ...",
        "MSG_LoadMask_InitWebAudioRecording": "Initing Web Audio Recorder, ...",
        "MSG_LoadMask_GetKeys4Systems": "Get Keys for Systems, ...",
        "MSG_LoadMask_CreateUser4App": "Create Account, ...",
        "MSG_LoadMask_UploadNewAssignmentTmpResult": "Save Assignment Result",
        "MSG_LoadMask_GetNewAssignmentAssignTmpAnswer": "Get Assignment Answer, ...",
        "MSG_LoadMask_AccountAcceptPCL": "Send Accept Parent Letter, ...",
        "MSG_LoadMask_GetLessonDataProcess": "Getting Lesson Data, ...",
        "MSG_LoadMask_UpdateProductCounter": "Update Product Data, ...",
        "MSG_LoadMask_LoadVideoData": "Loading Video Data, ...",
        "MSG_LoadMask_SendAccountVerifyEmail": "Send Verify Email, ...",
        "MSG_LoadMask_VerifyAccountEmail": "Verify Email, ...",
        "MSG_LoadMask_LoadingAudios": "Loading Audios, ...",
        "MSG_LoadMask_ProcessInAppPurchase": "Processing In App Purchase, ...",
        "MSG_LoadMask_GetListeningPDFFileKeyFromFS": "Get PDF File Key, ...",
        "MSG_LoadMask_GetSubscriptionReminder": "Get Subscription Data, ... ",
        
        // #endregion Load Mask Message
    }
}

export default gobjUISettings